// Translations for Alpha Watch Kristian Y. — DE / EN

export const translations = {
  de: {
    nav: {
      home: "Start",
      about: "Über uns",
      services: "Leistungen",
      gallery: "Katalog",
      catalog: "Katalog",
      contact: "Kontakt",
    },
    hero: {
      eyebrow: "Zürich · Atelier",
      title_line1: "Zeitlose Eleganz",
      title_line2: "in Meisterhand",
      subtitle: "Spezialist für Luxusuhren und Goldschmiedearbeiten im Herzen Zürichs.",
      cta_primary: "Anfrage via WhatsApp",
      cta_secondary: "Leistungen entdecken",
    },
    intro: {
      eyebrow: "Atelier Alpha Watch",
      heading: "Eine stille Hingabe an das Außergewöhnliche.",
      body: "Im Schatten der Bahnhofstrasse pflegt Kristian Y. eine fast vergessene Tradition: die kompromisslose Verbindung aus Schweizer Uhrmacherkunst und feinster Goldschmiedekunst. Jedes Stück, das unser Atelier verlässt, trägt die unsichtbare Signatur jahrzehntelanger Erfahrung.",
    },
    services_teaser: {
      eyebrow: "Leistungen",
      heading: "Zwei Disziplinen. Eine Hingabe.",
      watches_title: "Luxusuhren",
      watches_desc: "An- und Verkauf, Wartung, Restaurierung sowie Authentifizierung von Zeitmessern aller Manufakturen.",
      goldsmith_title: "Goldschmiedearbeiten",
      goldsmith_desc: "Individuelle Anfertigungen, Restaurierung von Erbstücken und feine Reparaturen aus eigener Werkstatt.",
      cta: "Mehr erfahren",
    },
    about: {
      eyebrow: "Über uns",
      heading: "Ihr vertrauensvoller Partner für Luxusuhren in Zürich.",
      p1: "Willkommen bei Alpha Watch Kristian Y. – Ihrem vertrauensvollen Partner für Luxusuhren und Goldschmiedearbeiten in Zürich. Wir haben uns auf den An- und Verkauf exklusiver Luxusuhren renommierter Marken spezialisiert und stehen für Zuverlässigkeit, Transparenz und kompromisslose Qualität. Unser Sortiment umfasst sowohl neue als auch sorgfältig ausgewählte gebrauchte Zeitmesser von Marken wie Rolex, Cartier, Breitling, Omega und Patek Philippe.",
      p2: "Bei Alpha Watch Kristian Y. steht Vertrauen an erster Stelle. Jede Uhr wird sorgfältig geprüft und auf Echtheit sowie einwandfreie Funktion kontrolliert. Auf die meisten unserer Uhren gewähren wir eine 2-jährige Garantie – wir stehen zu 100 % hinter der Qualität und Authentizität unserer Zeitmesser. Unser Ziel: nicht nur exklusive Uhren anzubieten, sondern eine langfristige und vertrauensvolle Beziehung aufzubauen.",
      services_title: "Unsere Dienstleistungen",
      services_list: [
        "An- und Verkauf von neuen sowie gebrauchten Luxusuhren",
        "Ankauf von Gold und Schmuck zu fairen Marktpreisen",
        "Professionelle Uhrenreparaturen und Revisionen",
        "Restaurierung von Luxus- und Vintage-Uhren",
        "Goldschmiedearbeiten und Schmuckreparaturen",
        "Sonderanfertigungen und individuelle Schmuckstücke",
        "Sichere, diskrete und vollständig versicherte Abwicklung",
      ],
      values_title: "Unsere Werte",
      values: [
        { title: "Vertrauen", body: "Jede Uhr wird auf Echtheit und Funktion geprüft. 2 Jahre Garantie auf die meisten Modelle." },
        { title: "Handwerk", body: "Uhrmacher- und Goldschmiedearbeiten in Präzision und Leidenschaft – im eigenen Atelier." },
        { title: "Diskretion", body: "Vertrauliche Beratung, sichere und vollständig versicherte Abwicklung." },
      ],
    },
    services: {
      eyebrow: "Leistungen",
      heading: "Meisterhandwerk in zwei Disziplinen.",
      watches: {
        title: "Luxusuhren",
        items: [
          { name: "An- und Verkauf", desc: "Faire Bewertung und seriöse Vermittlung von Zeitmessern aller bedeutenden Manufakturen." },
          { name: "Wartung & Revision", desc: "Komplette Werkrevision nach den Richtlinien der Hersteller — von Vintage bis Moderne." },
          { name: "Reparatur & Restaurierung", desc: "Behutsame Wiederherstellung historischer Stücke unter Erhalt der Originalsubstanz." },
          { name: "Authentifizierung", desc: "Prüfung von Echtheit, Werk, Zifferblatt und Gehäuse mit detaillierter Dokumentation." },
        ],
      },
      goldsmith: {
        title: "Goldschmiedearbeiten",
        items: [
          { name: "Individuelle Anfertigungen", desc: "Vom ersten Entwurf bis zum vollendeten Schmuckstück — gefertigt nach Ihren Vorstellungen." },
          { name: "Restaurierungen", desc: "Behutsame Aufarbeitung von Erbstücken mit Respekt vor der ursprünglichen Handschrift." },
          { name: "Reparaturen", desc: "Diskrete und präzise Instandsetzungen von Ketten, Ringen, Verschlüssen und Fassungen." },
          { name: "Umarbeitungen", desc: "Neuinterpretation bestehender Stücke — modern, tragbar, persönlich." },
        ],
      },
    },
    gallery: {
      eyebrow: "Atelier",
      heading: "Eine Auswahl aus unserer Werkstatt.",
      subtitle: "Augenblicke aus dem Atelier, ausgewählte Zeitmesser und feinste Goldschmiedearbeit.",
    },
    catalog: {
      eyebrow: "Katalog",
      heading: "Aktuell verfügbare Zeitmesser.",
      subtitle: "Eine kuratierte Auswahl aus unserem Atelier in Zürich. Für jede Uhr beraten wir Sie gerne persönlich — diskret und ohne Verpflichtung.",
    },
    contact: {
      eyebrow: "Kontakt",
      heading: "Wir freuen uns auf Ihren Besuch.",
      subtitle: "Eine Voranmeldung garantiert Ihnen unsere ungeteilte Aufmerksamkeit.",
      address_title: "Atelier",
      address_lines: ["Alpha Watch Kristian Y.", "Brandschenkestrasse 6", "8001 Zürich · Schweiz"],
      hours_title: "Öffnungszeiten",
      hours_lines: ["Di – Fr · 10:00 – 18:00", "Sa · 12:00 – 16:00", "So & Mo · nach Vereinbarung"],
      contact_title: "Direkter Kontakt",
      whatsapp_cta: "Über WhatsApp schreiben",
      whatsapp_note: "Antwort üblicherweise innerhalb einer Stunde während der Öffnungszeiten.",
    },
    footer: {
      tagline: "Spezialist für Luxusuhren und Goldschmiedearbeiten in Zürich.",
      nav_title: "Navigation",
      services_title: "Leistungen",
      contact_title: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
      imprint: "Impressum",
      privacy: "Datenschutz",
      cookies: "Cookie-Einstellungen",
    },
    cookies: {
      title: "Cookies & Datenschutz",
      text: "Wir verwenden notwendige Cookies für den Betrieb dieser Website. Mit Ihrer Zustimmung nutzen wir zusätzlich Statistik-Dienste (Google Analytics, PostHog inkl. Sitzungsaufzeichnung) und Marketing-Dienste (Google Tag Manager, Google Ads Conversion-Tracking). Ihre Wahl können Sie jederzeit über „Cookie-Einstellungen“ im Footer ändern oder widerrufen.",
      more: "Datenschutzerklärung",
      accept: "Alle akzeptieren",
      decline: "Nur notwendige",
      settings: "Einstellungen",
      save: "Auswahl speichern",
      necessary_title: "Notwendig",
      necessary_desc: "Speichert Ihre Sprach- und Cookie-Auswahl. Immer aktiv.",
      statistics_title: "Statistik",
      statistics_desc: "Google Analytics 4 und PostHog (inkl. Sitzungsaufzeichnung und Heatmaps) helfen uns zu verstehen, wie die Website genutzt wird.",
      marketing_title: "Marketing",
      marketing_desc: "Google Tag Manager und Google Ads Conversion-Tracking messen den Erfolg unserer Anzeigen.",
    },
    service_list: {
      eyebrow: "Leistungsübersicht",
      heading: "Alle Leistungen auf einen Blick.",
      intro: "Uhrmacherei, Goldschmiede und Ankauf – persönlich beraten in unserem Atelier an der Brandschenkestrasse in Zürich.",
      price_note: "Preis auf Anfrage – individuelle Preisabklärung nach Begutachtung.",
      cta_appointment: "Termin vereinbaren",
      cta_inquiry: "Jetzt anfragen",
      msg_appointment: "Guten Tag, ich möchte einen Termin vereinbaren für: ",
      msg_inquiry: "Guten Tag, ich habe eine Anfrage zu: ",
      items: [
        { id: "batteriewechsel", title: "Batteriewechsel bei Uhren", desc: "Fachgerechter Batteriewechsel für Quarzuhren aller Marken – von der Alltagsuhr bis zur Luxusuhr. Wir öffnen und schliessen das Gehäuse mit dem passenden Werkzeug, damit Gehäuse und Dichtungen geschützt bleiben." },
        { id: "uhrenrevision", title: "Uhrenrevision & Uhrmacherei", desc: "Komplette Revision mechanischer und automatischer Uhren: Zerlegen, Reinigen, Ölen, Regulieren und Funktionsprüfung des Uhrwerks. So bleibt Ihre Uhr präzise und werterhaltend.", highlight: "2 Jahre Garantie nach jeder Revision" },
        { id: "uhrenreparatur", title: "Uhrenreparaturen", desc: "Reparatur von Luxus- und Vintage-Uhren, etwa bei Gangabweichungen, defekter Krone, Glasschäden oder Problemen mit dem Armband. Nach der Begutachtung erklären wir Ihnen transparent, welche Arbeiten notwendig sind." },
        { id: "uhrenpolitur", title: "Uhrenpolitur", desc: "Professionelle Aufarbeitung von Gehäuse und Armband: Kratzer und Gebrauchsspuren werden behutsam entfernt, polierte und satinierte Flächen wieder sauber herausgearbeitet." },
        { id: "goldankauf", title: "Goldankauf", desc: "Ankauf von Altgold und Goldschmuck zu fairen Marktpreisen. Die Bewertung erfolgt transparent und diskret in unserem Atelier in Zürich." },
        { id: "schmuckankauf", title: "Schmuckankauf", desc: "Wir kaufen hochwertigen Schmuck – etwa Ringe, Ketten, Armbänder oder Ohrschmuck – diskret und zu fairen Preisen an. Gerne beurteilen wir Ihre Stücke persönlich im Atelier." },
        { id: "schmuckreparatur", title: "Schmuckreparaturen", desc: "Reparaturen aus der eigenen Goldschmiedewerkstatt: Ketten löten, Ringgrössen anpassen, Verschlüsse ersetzen sowie Fassungen kontrollieren – präzise und mit Respekt vor dem Original." },
      ],
    },
    meta: {
      home: { title: "Alpha Watch Kristian Y. · Luxusuhren & Goldschmiede in Zürich", desc: "Alpha Watch Kristian Y. in Zürich: Uhrenrevision mit 2 Jahren Garantie, Uhrenreparatur, Batteriewechsel, Uhrenpolitur, Gold- und Schmuckankauf sowie Schmuckreparaturen." },
      about: { title: "Über uns · Alpha Watch Kristian Y. Zürich", desc: "Ihr Partner für Luxusuhren, Uhrenservice und Goldschmiedearbeiten in Zürich – geprüfte Echtheit und 2 Jahre Garantie auf die meisten Uhren." },
      services: { title: "Leistungen · Uhrenrevision, Batteriewechsel & Goldankauf Zürich", desc: "Batteriewechsel, Uhrenrevision mit 2 Jahren Garantie, Uhrenreparatur, Uhrenpolitur, Goldankauf, Schmuckankauf und Schmuckreparaturen in Zürich. Preis auf Anfrage." },
      contact: { title: "Kontakt · Alpha Watch Zürich, Brandschenkestrasse 6", desc: "Termin vereinbaren per WhatsApp, Telefon oder E-Mail: Alpha Watch Kristian Y., Brandschenkestrasse 6, 8001 Zürich." },
      impressum: { title: "Impressum · Alpha Watch Kristian Y.", desc: "Impressum von Alpha Watch Kristian Y., Brandschenkestrasse 6, 8001 Zürich." },
      privacy: { title: "Datenschutzerklärung · Alpha Watch Kristian Y.", desc: "Datenschutzerklärung von Alpha Watch Kristian Y. gemäss Schweizer Datenschutzgesetz (DSG)." },
    },
    whatsapp: {
      label: "WhatsApp",
      tooltip: "Anfrage via WhatsApp",
      default_message: "Guten Tag, ich interessiere mich für eine Beratung im Atelier.",
    },
    closing: {
      home_quote: "„Zeit ist die wertvollste Materie, die wir veredeln.\"",
      contact_quote: "„Wahre Qualität verlangt Zeit — und ein offenes Gespräch.\"",
      services_title: "Haben Sie ein besonderes Anliegen?",
      services_subtitle: "Jede Anfrage wird persönlich von Kristian Y. beantwortet.",
      values_heading: "Drei Prinzipien, eine Haltung.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      gallery: "Catalog",
      catalog: "Catalog",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Zurich · Atelier",
      title_line1: "Timeless elegance",
      title_line2: "in master hands",
      subtitle: "Specialist for luxury watches and goldsmithing in the heart of Zurich.",
      cta_primary: "Appointment via WhatsApp",
      cta_secondary: "Discover services",
    },
    intro: {
      eyebrow: "Atelier Alpha Watch",
      heading: "A quiet devotion to the exceptional.",
      body: "In the shadow of Bahnhofstrasse, Kristian Y. preserves a nearly forgotten tradition: the uncompromising union of Swiss watchmaking and the finest goldsmithing. Every piece that leaves our atelier bears the invisible signature of decades of experience.",
    },
    services_teaser: {
      eyebrow: "Services",
      heading: "Two disciplines. One devotion.",
      watches_title: "Luxury watches",
      watches_desc: "Buying, selling, servicing, restoration and authentication of timepieces from every manufacture.",
      goldsmith_title: "Goldsmithing",
      goldsmith_desc: "Bespoke creations, restoration of heirlooms and refined repairs from our own workshop.",
      cta: "Learn more",
    },
    about: {
      eyebrow: "About",
      heading: "Your trusted partner for luxury watches in Zurich.",
      p1: "Welcome to Alpha Watch Kristian Y. – your trusted partner for luxury watches and goldsmithing in Zurich. We specialise in the purchase and sale of exclusive timepieces from renowned brands and stand for reliability, transparency and uncompromising quality. Our selection includes both new and carefully chosen pre-owned timepieces from Rolex, Cartier, Breitling, Omega and Patek Philippe.",
      p2: "At Alpha Watch Kristian Y. trust comes first. Every watch is carefully inspected for authenticity and flawless function. On most of our watches we provide a 2-year warranty — we stand 100% behind the quality and authenticity of our timepieces. Our goal is to build long-lasting, trust-based relationships through personal consultation, discretion and the highest professionalism.",
      services_title: "Our Services",
      services_list: [
        "Buying and selling of new and pre-owned luxury watches",
        "Purchase of gold and jewellery at fair market prices",
        "Professional watch repairs and overhauls",
        "Restoration of luxury and vintage watches",
        "Goldsmithing and jewellery repairs",
        "Bespoke creations and individual jewellery pieces",
        "Secure, discreet and fully insured handling",
      ],
      craft_title: "Watchmaking & Goldsmithing",
      craft_p: "Our experienced watchmakers and goldsmiths work with the utmost precision and great passion for their craft. Whether a complete overhaul of your luxury watch, restoration of a vintage model or refinement of your jewellery — we place the highest value on quality and attention to detail. Decades of experience allow us to combine traditional craftsmanship with modern technology to preserve the brilliance and functionality of your treasured pieces.",
      trust_title: "Trust & Security",
      trust_p: "Every watch is carefully inspected before handover or shipping. Customer satisfaction and long-term relationships are our highest priority. We guarantee secure and discreet handling as well as personal support throughout the entire process.",
      values_title: "Our values",
      values: [
        { title: "Trust", body: "Every watch checked for authenticity and function. 2-year warranty on most models." },
        { title: "Craftsmanship", body: "Watchmaking and goldsmithing in precision and passion — in our own atelier." },
        { title: "Discretion", body: "Confidential consultation, secure and fully insured handling." },
      ],
    },
    services: {
      eyebrow: "Services",
      heading: "Master craftsmanship in two disciplines.",
      watches: {
        title: "Luxury watches",
        items: [
          { name: "Buying & selling", desc: "Fair valuation and trusted brokerage of timepieces from all major manufactures." },
          { name: "Service & overhaul", desc: "Complete movement overhaul following manufacturer guidelines — from vintage to modern." },
          { name: "Repair & restoration", desc: "Careful restoration of historical pieces while preserving original substance." },
          { name: "Authentication", desc: "Verification of authenticity, movement, dial and case with detailed documentation." },
        ],
      },
      goldsmith: {
        title: "Goldsmithing",
        items: [
          { name: "Bespoke creations", desc: "From the first sketch to the finished piece — crafted entirely to your vision." },
          { name: "Restorations", desc: "Sensitive restoration of heirlooms with respect for the original signature." },
          { name: "Repairs", desc: "Discreet and precise repair of chains, rings, clasps and settings." },
          { name: "Reworking", desc: "Reinterpretation of existing pieces — modern, wearable, personal." },
        ],
      },
    },
    gallery: {
      eyebrow: "Atelier",
      heading: "A selection from our workshop.",
      subtitle: "Moments from the atelier, selected timepieces and the finest goldsmithing.",
    },
    catalog: {
      eyebrow: "Catalog",
      heading: "Currently available timepieces.",
      subtitle: "A curated selection from our atelier in Zurich. For every watch we offer personal advice — discreet and without obligation.",
    },
    contact: {
      eyebrow: "Contact",
      heading: "We look forward to your visit.",
      subtitle: "Booking an appointment guarantees you our undivided attention.",
      address_title: "Atelier",
      address_lines: ["Alpha Watch Kristian Y.", "Brandschenkestrasse 6", "8001 Zürich · Switzerland"],
      hours_title: "Opening hours",
      hours_lines: ["Tue – Fri · 10:00 – 18:00", "Sat · 12:00 – 16:00", "Sun & Mon · by appointment"],
      contact_title: "Direct contact",
      whatsapp_cta: "Write via WhatsApp",
      whatsapp_note: "Usually answered within an hour during opening hours.",
    },
    footer: {
      tagline: "Specialist for luxury watches and goldsmithing in Zurich.",
      nav_title: "Navigation",
      services_title: "Services",
      contact_title: "Contact",
      rights: "All rights reserved.",
      imprint: "Imprint",
      privacy: "Privacy",
      cookies: "Cookie settings",
    },
    cookies: {
      title: "Cookies & Privacy",
      text: "We use necessary cookies to operate this website. With your consent, we additionally use statistics services (Google Analytics, PostHog incl. session recording) and marketing services (Google Tag Manager, Google Ads conversion tracking). You can change or withdraw your choice at any time via “Cookie settings” in the footer.",
      more: "Privacy policy",
      accept: "Accept all",
      decline: "Necessary only",
      settings: "Settings",
      save: "Save selection",
      necessary_title: "Necessary",
      necessary_desc: "Stores your language and cookie choice. Always active.",
      statistics_title: "Statistics",
      statistics_desc: "Google Analytics 4 and PostHog (incl. session recording and heatmaps) help us understand how the website is used.",
      marketing_title: "Marketing",
      marketing_desc: "Google Tag Manager and Google Ads conversion tracking measure the success of our ads.",
    },
    service_list: {
      eyebrow: "Service overview",
      heading: "All services at a glance.",
      intro: "Watchmaking, goldsmithing and purchasing – personal advice in our atelier on Brandschenkestrasse in Zurich.",
      price_note: "Price on request – individual quote after inspection.",
      cta_appointment: "Book an appointment",
      cta_inquiry: "Send an inquiry",
      msg_appointment: "Hello, I would like to book an appointment for: ",
      msg_inquiry: "Hello, I have an inquiry about: ",
      items: [
        { id: "batteriewechsel", title: "Watch battery replacement", desc: "Professional battery replacement for quartz watches of all brands – from everyday watches to luxury timepieces. We open and close the case with the proper tools so that case and gaskets stay protected." },
        { id: "uhrenrevision", title: "Watch servicing & watchmaking", desc: "Complete service of mechanical and automatic watches: disassembly, cleaning, oiling, regulation and function check of the movement – keeping your watch precise and preserving its value.", highlight: "2-year warranty after every service" },
        { id: "uhrenreparatur", title: "Watch repairs", desc: "Repair of luxury and vintage watches, e.g. for rate deviations, a defective crown, glass damage or bracelet issues. After inspection we explain transparently which work is required." },
        { id: "uhrenpolitur", title: "Watch polishing", desc: "Professional refinishing of case and bracelet: scratches and signs of wear are carefully removed, polished and brushed surfaces are restored cleanly." },
        { id: "goldankauf", title: "Gold purchase", desc: "We buy old gold and gold jewellery at fair market prices. The valuation takes place transparently and discreetly in our atelier in Zurich." },
        { id: "schmuckankauf", title: "Jewellery purchase", desc: "We buy fine jewellery – such as rings, necklaces, bracelets or earrings – discreetly and at fair prices. We are happy to assess your pieces personally in our atelier." },
        { id: "schmuckreparatur", title: "Jewellery repairs", desc: "Repairs from our own goldsmith workshop: soldering chains, resizing rings, replacing clasps and checking settings – precise and with respect for the original." },
      ],
    },
    meta: {
      home: { title: "Alpha Watch Kristian Y. · Luxury watches & goldsmith in Zurich", desc: "Alpha Watch Kristian Y. in Zurich: watch servicing with 2-year warranty, watch repairs, battery replacement, polishing, gold and jewellery purchase and jewellery repairs." },
      about: { title: "About us · Alpha Watch Kristian Y. Zurich", desc: "Your partner for luxury watches, watch service and goldsmithing in Zurich – verified authenticity and a 2-year warranty on most watches." },
      services: { title: "Services · Watch servicing, battery replacement & gold purchase Zurich", desc: "Battery replacement, watch servicing with 2-year warranty, watch repairs, polishing, gold purchase, jewellery purchase and jewellery repairs in Zurich. Price on request." },
      contact: { title: "Contact · Alpha Watch Zurich, Brandschenkestrasse 6", desc: "Book an appointment via WhatsApp, phone or e-mail: Alpha Watch Kristian Y., Brandschenkestrasse 6, 8001 Zurich." },
      impressum: { title: "Imprint · Alpha Watch Kristian Y.", desc: "Imprint of Alpha Watch Kristian Y., Brandschenkestrasse 6, 8001 Zurich." },
      privacy: { title: "Privacy policy · Alpha Watch Kristian Y.", desc: "Privacy policy of Alpha Watch Kristian Y. in accordance with the Swiss Data Protection Act (FADP)." },
    },
    whatsapp: {
      label: "WhatsApp",
      tooltip: "Request appointment via WhatsApp",
      default_message: "Good day, I am interested in a consultation at your atelier.",
    },
    closing: {
      home_quote: "\"Time is the most precious matter we refine.\"",
      contact_quote: "\"True quality demands time — and an open conversation.\"",
      services_title: "Do you have a particular request?",
      services_subtitle: "Every inquiry is answered personally by Kristian Y.",
      values_heading: "Three principles, one stance.",
    },
  },
};
